import {HomeForecastPeriod, IHomeDashboard, IInventoryForecast, IPurchaseForecast} from '../models/Home/IHomeDashboard';
import {normalizeOrderGroupsGuid} from '../mappers/orderGuid.mapper';
import {baseAPI} from './BaseAPI';

export const homeAPI = baseAPI.injectEndpoints({
    endpoints: build => ({
        getDashboard: build.query<IHomeDashboard, number>({
            query: days => ({url: 'dashboard/v2', method: 'GET', params: {days}}),
            transformResponse: (response: IHomeDashboard) => ({...response, orders: normalizeOrderGroupsGuid(response.orders)}),
            providesTags: [{type: 'OrderV2', id: 'LIST'}, {type: 'Item', id: 'RequiredItems'}],
        }),
        getInventoryForecast: build.query<IInventoryForecast, HomeForecastPeriod>({
            query: days => ({url: 'inventory/forecast/v2', method: 'GET', params: {days}}),
            providesTags: [{type: 'OrderV2', id: 'LIST'}, {type: 'Item', id: 'RequiredItems'}],
        }),
        getPurchaseForecast: build.query<IPurchaseForecast, HomeForecastPeriod>({
            query: days => ({url: 'purchases/forecast/v2', method: 'GET', params: {days}}),
            providesTags: [{type: 'OrderV2', id: 'LIST'}, {type: 'Item', id: 'RequiredItems'}],
        }),
    }),
});
